var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1484 12.3374C13.3202 12.3802 14.4386 13.2704 14.4386 13.2704C14.4386 13.2704 13.7843 13.0293 12.7025 12.8039C11.4214 12.5371 10.1484 12.3374 10.1484 12.3374Z",
    fill: "#BBC8FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5174 4.05371C10.5174 4.05371 10.4823 5.37379 10.5174 5.9216C10.5526 6.46941 10.0391 8.30068 10.0391 8.30068C10.0391 8.30068 10.7067 6.96587 10.7238 6.07567C10.7409 5.18595 10.5174 4.05371 10.5174 4.05371Z",
    fill: "#BBC8FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2537 5.30859C14.2537 5.30859 14.3531 6.62582 14.4439 7.16697C14.5348 7.70813 14.2109 9.5822 14.2109 9.5822C14.2109 9.5822 14.7388 8.18604 14.6651 7.29917C14.5914 6.4123 14.2537 5.30859 14.2537 5.30859Z",
    fill: "#BBC8FA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1976 13.9828C9.7414 12.4164 6.74416 12.0393 1.48438 11.9404C1.63226 8.18511 1.80726 6.36002 2.30466 2.86914C8.23969 3.63094 11.5261 4.37372 18.4664 6.73712C17.4454 9.4505 16.9808 10.9109 16.1976 13.9833V13.9828Z",
    fill: "#8EAB60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9664 6.73078C16.9698 6.72079 16.9793 6.71509 16.9831 6.70558C11.1907 4.85861 8.43549 4.24327 3.37067 3.53711C3.36924 3.549 3.37352 3.55993 3.37162 3.5723C3.31313 3.95796 2.9874 4.23376 2.64074 4.20143C2.29931 6.73601 2.16902 8.04325 2.00781 10.7167C2.30311 10.739 2.51948 11.0439 2.52709 11.4195C7.1045 11.624 9.64666 11.9664 15.0738 13.2294C15.1889 12.9174 15.5394 12.7353 15.9036 12.8261C16.4809 10.6225 16.8062 9.56162 17.5095 7.54299C17.0991 7.41222 16.8556 7.04891 16.966 6.73126L16.9664 6.73078Z",
    fill: "#C3DB7B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2428 8.94442C11.8605 10.5375 10.2408 11.616 8.63449 11.3744C7.02769 11.1323 5.94444 9.54977 6.21264 7.81266C6.48084 6.07554 8.09525 4.95709 9.81617 5.34274C11.5371 5.72888 12.6251 7.35139 12.2428 8.94442Z",
    fill: "#8EAB60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.6645 7.49121C3.7344 6.89822 4.21706 6.47167 4.74252 6.5411C5.26797 6.611 5.62605 7.13884 5.54235 7.71709C5.45866 8.29533 4.976 8.71713 4.46434 8.66197C3.95267 8.60681 3.59508 8.0842 3.66498 7.49073L3.6645 7.49121Z",
    fill: "#8EAB60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.2773 9.18697C13.409 8.66959 13.9901 8.37476 14.575 8.53121C15.1599 8.68719 15.5185 9.22169 15.3753 9.72194C15.2322 10.2222 14.6506 10.5137 14.0771 10.3739C13.5032 10.2346 13.1456 9.70387 13.2773 9.18697Z",
    fill: "#8EAB60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30466 2.86816C1.80726 6.35904 1.63226 8.18461 1.48438 11.9399C6.74464 12.0388 9.74188 12.4159 16.1976 13.9823C16.9808 10.9099 17.4454 9.45 18.4664 6.73614C11.5256 4.37275 8.23969 3.62997 2.30466 2.86816Z",
    fill: "#8EAB60"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9816 14.3094C8.76315 11.9702 5.83391 11.2322 0.625 10.4951C1.22797 6.78552 1.62313 4.99514 2.54089 1.59033C8.33945 3.06733 11.5112 4.20338 18.1129 7.39277C16.7701 9.96207 16.1319 11.3549 14.9811 14.3094H14.9816Z",
    fill: "#8EAB60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6214 7.2052C16.6262 7.19569 16.6362 7.19094 16.6414 7.1819C11.1158 4.64494 8.45571 3.70006 3.51357 2.38379C3.51072 2.39568 3.51357 2.40709 3.51024 2.41898C3.40515 2.79465 3.04851 3.02861 2.70851 2.9549C2.06179 5.42909 1.77362 6.71065 1.28906 9.3451C1.57961 9.40311 1.75746 9.7317 1.71941 10.1059C6.23786 10.8649 8.7201 11.5135 13.9537 13.4261C14.1059 13.1303 14.4759 12.9924 14.8263 13.1265C15.6671 11.0095 16.1188 9.9961 17.0618 8.07781C16.6704 7.89806 16.4731 7.50812 16.621 7.20616L16.6214 7.2052Z",
    fill: "#C3DB7B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6732 8.82769C11.1002 10.3622 9.36164 11.2363 7.79621 10.8011C6.23078 10.366 5.34773 8.66363 5.82468 6.97169C6.30163 5.28023 8.04015 4.36578 9.70116 4.95781C11.3627 5.54985 12.2457 7.29268 11.6727 8.82722L11.6732 8.82769Z",
    fill: "#8EAB60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.32487 6.34351C3.4661 5.76336 3.99727 5.39816 4.50988 5.5313C5.0225 5.66445 5.314 6.23176 5.16088 6.79574C5.00776 7.35972 4.47707 7.7197 3.97587 7.60272C3.47466 7.48574 3.18317 6.92319 3.32487 6.34304V6.34351Z",
    fill: "#8EAB60"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.6695 9.19383C12.863 8.69643 13.4755 8.47435 14.0371 8.70023C14.5987 8.92611 14.8897 9.50007 14.6872 9.97941C14.4846 10.4587 13.8716 10.677 13.3191 10.4687C12.7665 10.2604 12.4755 9.69076 12.6695 9.19336V9.19383Z",
    fill: "#8EAB60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54089 1.59033C1.62313 4.99514 1.22797 6.78552 0.625 10.4951C5.83391 11.2322 8.76315 11.9702 14.9816 14.3094C16.1319 11.3549 16.7705 9.96207 18.1134 7.39277C11.5112 4.20338 8.33945 3.06733 2.54089 1.59033Z",
    fill: "#8EAB60"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3831 16.2624C8.8989 12.5133 6.22835 11.1005 1.34375 9.14699C2.81075 5.68702 3.61962 4.04168 5.31962 0.952148C10.6018 3.76397 13.4126 5.62139 19.068 10.2873C17.1536 12.4643 16.2025 13.666 14.3831 16.2624Z",
    fill: "#8EAB60"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 9.75092C17.6736 9.74284 17.6845 9.74046 17.6917 9.73285C12.9274 5.95665 10.5678 4.40689 6.07982 1.9541C6.07459 1.96504 6.07459 1.97645 6.0684 1.98739C5.87724 2.32739 5.47542 2.47005 5.16205 2.31741C3.94613 4.56715 3.36171 5.74361 2.26562 8.18737C2.5343 8.31291 2.62845 8.67432 2.50291 9.02859C6.71227 10.8389 8.96911 12.0587 13.5984 15.1596C13.8161 14.9085 14.2089 14.8624 14.5171 15.0759C15.8367 13.219 16.5162 12.3421 17.8881 10.7025C17.5504 10.4347 17.4511 10.0091 17.667 9.75092Z",
    fill: "#C3DB7B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4682 10.1501C11.5471 11.5044 9.65073 11.9409 8.23366 11.1463C6.81659 10.3517 6.36294 8.48809 7.2284 6.9583C8.09338 5.42852 9.99929 4.95299 11.4725 5.92307C12.9456 6.89316 13.3893 8.79576 12.4682 10.1501Z",
    fill: "#8EAB60"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.95828 5.75596C5.23361 5.22574 5.83562 4.99749 6.30259 5.24857C6.76908 5.49965 6.91744 6.12022 6.63451 6.63141C6.35157 7.14261 5.75098 7.36659 5.29162 7.13405C4.83274 6.90152 4.68295 6.2857 4.95828 5.75596Z",
    fill: "#8EAB60"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3474 10.7432C13.6536 10.3062 14.3013 10.2358 14.793 10.5887C15.2846 10.9415 15.4311 11.5683 15.1206 11.9858C14.8096 12.4033 14.1629 12.4699 13.6755 12.1365C13.1881 11.8032 13.0411 11.1802 13.3474 10.7432Z",
    fill: "#8EAB60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31962 0.952148C3.61962 4.04168 2.81075 5.68702 1.34375 9.14699C6.22883 11.1005 8.8989 12.5133 14.3831 16.2624C16.2025 13.666 17.1536 12.4643 19.068 10.2873C13.4126 5.62139 10.6018 3.76444 5.31962 0.952148Z",
    fill: "#8EAB60"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0711 17.5652C9.35008 12.8912 6.97769 11.0214 2.52344 8.22149C4.58865 5.08155 5.68045 3.60836 7.90829 0.875C12.5984 4.5908 15.0298 6.92329 19.7541 12.5303C17.4792 14.3273 16.3275 15.3383 14.0711 17.5652Z",
    fill: "#8EAB60"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4703 11.7502C18.4784 11.7436 18.4893 11.7431 18.4979 11.7374C14.4901 7.16562 12.4478 5.21642 8.4738 1.99707C8.46667 2.00658 8.46476 2.01847 8.45668 2.0275C8.2075 2.32756 7.78619 2.39557 7.5061 2.18919C5.90548 4.18356 5.11896 5.23592 3.60156 7.44286C3.84313 7.61453 3.87119 7.98687 3.68383 8.31308C7.49897 10.8505 9.49951 12.4564 13.4958 16.3391C13.7555 16.1313 14.1497 16.1565 14.4145 16.4218C16.0465 14.8326 16.8725 14.0917 18.5169 12.726C18.233 12.4017 18.2121 11.9656 18.4703 11.7502Z",
    fill: "#C3DB7B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2889 11.2093C12.1391 12.3762 10.1956 12.4642 8.94405 11.428C7.69294 10.3918 7.58167 8.47688 8.70771 7.12732C9.83376 5.77776 11.7943 5.65318 13.0688 6.87196C14.3436 8.09075 14.4383 10.0423 13.2885 11.2093H13.2889Z",
    fill: "#8EAB60"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.68265 5.53468C7.04881 5.06296 7.68221 4.94645 8.09592 5.27742C8.50962 5.60839 8.54386 6.24513 8.1739 6.69736C7.80394 7.14959 7.17245 7.26182 6.76254 6.95034C6.35264 6.63934 6.31602 6.00641 6.68218 5.53468H6.68265Z",
    fill: "#8EAB60"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.0462 11.9504C14.4261 11.5757 15.0757 11.6228 15.496 12.0584C15.9164 12.494 15.9478 13.1369 15.5669 13.4916C15.186 13.8468 14.5379 13.7955 14.1184 13.3799C13.699 12.9643 13.6662 12.3251 14.0462 11.9504Z",
    fill: "#8EAB60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.a4af4ba9d47d659b3e0c7430a5f6c5fb.svg";
export { ForwardRef as ReactComponent };